import React from 'react';
import { SubpageLayout } from '../components/SubpageLayout';
import { WorkCard } from '../components/WorkCard';
import { allProjects } from '../utils/projects';

/** All projects, two per row. */
export function WorkIndex() {
  return <SubpageLayout title="Work" data-id="element-606" data-mp="1goziohczfl0k">
      <section aria-labelledby="work-index-heading" className="px-page pb-20 pt-36 md:pb-28 md:pt-44" data-id="element-607" data-mp="1gor66qkruhpw">
        <p className="text-[12px] font-medium uppercase tracking-[0.04em] text-fg/60" data-id="element-608" data-mp="1qgdloz4572yg">
          All work <span className="text-fg/40" data-id="element-609" data-mp="1uhyw8dt7f55h">({String(allProjects.length).padStart(2, '0')})</span>
        </p>
        <h1 id="work-index-heading" className="mt-4 max-w-[760px] font-serif text-[36px] font-normal leading-[1.08] tracking-[-0.01em] md:text-[56px]" data-id="element-610" data-mp="1zh203uxg75bv">
          Brands, terminals and assets — built and operated from <span className="text-fg/40" data-id="element-611" data-mp="542f1maatix7">one source</span>.
        </h1>

        <ul className="mt-14 grid grid-cols-1 gap-x-[var(--gutter)] gap-y-16 md:mt-20 md:grid-cols-2 md:gap-y-20" data-id="element-612" data-mp="a1vii7k7vyts">
          {allProjects.map(p => <WorkCard key={p.slug} slug={p.slug} title={p.title} meta={p.summary} image={p.image} tags={p.tags} data-id="element-613" data-mp="1eqyesqyzrfnt" />)}
        </ul>
      </section>
    </SubpageLayout>;
}